import {Component, Input, OnInit} from '@angular/core';
import {Document, DocumentService} from '../../common/services';

@Component({
  selector: 'p8-bdc-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {
  @Input() documents: Document[];

  constructor(private documentService: DocumentService) { }

  ngOnInit() {
  }

  download(doc: Document) {
    if (this.documentService) {
      this.documentService.download(doc);
    }
  }

  getPicto(doc: Document) {
    if (this.documentService) {
      return this.documentService.getPictoFromExtension(doc);
    }
  }
}
